export const ASSIGNED_TO_WRITERS_REPORT_LOADING =
  'ASSIGNED_TO_WRITERS_REPORT_LOADING';
export const ASSIGNED_TO_WRITERS_REPORT_SUCCESS =
  'ASSIGNED_TO_WRITERS_REPORT_SUCCESS';
export const ASSIGNED_TO_WRITERS_REPORT_ERROR =
  'ASSIGNED_TO_WRITERS_REPORT_ERROR';
